import React from 'react';
import { Button } from './ui/button';
import { images, contactInfo } from '../data/mock';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const NewHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const ctaLink = "https://calendly.com/davwaysolution/review";

  return (
    <header className="fixed top-0 left-0 right-0 z-50" style={{ backgroundColor: '#0B1F3A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={images.logo} 
              alt="Davway Solutions" 
              className="h-14 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#calculator" className="text-gray-300 hover:text-gold-400 font-medium transition-colors" style={{ color: '#D4AF37' }}>Calculator</a>
            <a href="#features" className="text-gray-300 hover:text-gold-400 font-medium transition-colors">Features</a>
            <a href="#how-it-works" className="text-gray-300 hover:text-gold-400 font-medium transition-colors">How It Works</a>
            <a href="#testimonials" className="text-gray-300 hover:text-gold-400 font-medium transition-colors">Reviews</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a href="/quick-check">
              <Button 
                className="text-white font-semibold px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                style={{ backgroundColor: '#22C55E' }}
              >
                Get Started
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-700">
            <nav className="flex flex-col space-y-4">
              <a href="#calculator" className="text-gray-300 font-medium" onClick={() => setMobileMenuOpen(false)} style={{ color: '#D4AF37' }}>Calculator</a>
              <a href="#features" className="text-gray-300 font-medium" onClick={() => setMobileMenuOpen(false)}>Features</a>
              <a href="#how-it-works" className="text-gray-300 font-medium" onClick={() => setMobileMenuOpen(false)}>How It Works</a>
              <a href="#testimonials" className="text-gray-300 font-medium" onClick={() => setMobileMenuOpen(false)}>Reviews</a>
              <a href="/quick-check">
                <Button 
                  className="text-white font-semibold w-full py-3 rounded-lg"
                  style={{ backgroundColor: '#22C55E' }}
                >
                  Get Started
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default NewHeader;
